export const data = {
    "status": "success",
    "message": "Pool Info",
    "data": {
        "pool_type": "staking",
        "pool_url": "https://i.imgur.com/6aAMsqC.png",
        "project_name": "Blockius",
        "factory_address": "0xf0D251b8b7AbC1a8C8aA4626EbA38022689cf0B1",
        "chain_id": "56",
        "chain_network": "BSC",
        "pool_address": "0x510a427581EFB83FBa0B112B75bC755C67c7209C",
        "pool_token": "0xd5e950837Ad48D08baD2f87bFcF8eD7167bB44BC",
        "pool_status": "Active",
        "pool_name": "Launchpad Staking"
    }
}